export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';
export const GET_HISTORY = 'GET_HISTORY';
export const REMOVE_HISTORY = 'REMOVE_HISTORY';
export const BACK_HISTORY = 'BACK_HISTORY';
export const FORWARD_HISTORY = 'FORWARD_HISTORY';
export const ADD_TIMELINES = 'ADD_TIMELINES';